import type { CommonCtx, EventMap } from './schema'

export interface Tracker {
  track<E extends keyof EventMap>(event: E, payload: EventMap[E], ctx?: Partial<CommonCtx>): void
  identify?(userId: string, traits?: Record<string, unknown>): void
}

export type Middleware = (next: Tracker) => Tracker

export function applyMiddleware(base: Tracker, ...mws: Middleware[]): Tracker {
  return mws.reduce((acc, mw) => mw(acc), base)
}

export function createTracker(base: Tracker, ...mws: Middleware[]): Tracker {
  return applyMiddleware(base, ...mws)
}
